export const FRIENDLY_NAMES = {
  OFF: 'Off',
  STAGE_ONE: 'Stage 1',
  STAGE_TWO: 'Stage 2',
  STAGE_ONE_HEAT: 'Stage 1 Heat',
  STAGE_TWO_HEAT: 'Stage 2 Heat',
  CONTINUOUS_FAN: 'Continuous Fan',
  STAGE_ONE_COMP_COOL: 'Stage 1 Comp Cooling',
  STAGE_TWO_COMP_COOL: 'Stage 2 Comp Cooling',
  STAGE_ONE_COMP_HEAT: 'Stage 1 Comp Heating',
  STAGE_TWO_COMP_HEAT: 'Stage 2 Comp Heating',
  VSPD_COMP_COOLING: 'VSPD Comp Cooling',
  VSPD_COMP_HEATING: 'VSPD Comp Heating',
  DEFROST: 'Defrost',
  STAGE_ONE_HEATING: 'Stage 1 Heating',
  STAGE_TWO_HEATING: 'Stage 2 Heating',
  MODULATING_HEATING: 'Modulating Heating',
  PRE_PURGE: 'Pre Purge',
  POST_PURGE: 'Post Purge',
  INTER_PURGE: 'Inter Purge',
  AUTO_RESTART_PURGE: 'Auto Restart Purge',
  IGNITOR_WARMUP: 'Ignitor Warmup',
  IGNITION_ACTIVATION: 'Ignition Activation',
  IGNITION_DEACTIVATION: 'Ignition Deactivation',
  TEST_IN_PROGRESS: 'Test In Progress',
  EOL_TEST_IN_PROGRESS: 'EOL Test In Progress',
  UNKNOWN: 'Unknown',
  IDLE: 'Idle',
  WAITING: 'Waiting',
  DEHUMIDIFYING: 'Dehumidifying',
  COOLING: 'Cooling',
  HEATING: 'Heating',
  FAN_RUNNING: 'Fan Running',
  EMERGENCY_HEATING: 'EM Heat',
  AUX_HEATING: 'Aux Heat',
  SERVICE_REQUIRED: 'Service Required',
  COOL_RELIEVING_AIR: 'Cool Relieving',
  HEAT_RELIEVING_AIR: 'Heat Relieving',
  EM_HEAT_RELIEVING_AIR: 'EM Heat Relieving',
  AUX_HEAT_RELIEVING_AIR: 'Aux Heat Relieving'
}

export const OUTDOOR_UNIT_TYPE = { COOLING_ONLY: 'Clg Only', HEAT_PUMP: 'HP' }
export const OUTDOOR_STAGES = { SINGLE_STAGE: 1, TWO_STAGE: 2, VARIABLE: 'VS' }
export const INDOOR_UNIT_TYPE = {
  GAS_OIL: 'Fossil',
  ELECTRIC: 'Elect',
  HYDRONIC: 'Hydro',
  HYDRONIC_RADIANT: 'Radiant - Hydro',
  HYDRONIC_FORCED_AIR: 'Forced Air - Hydro'
}
export const INDOOR_STAGES = { SINGLE_STAGE: 1, TWO_STAGE: 2, THREE_STAGE: 3 }
export const COMPRESSOR_TYPE = {
  SINGLE_COMPRESSOR_ONE_STAGE: '1 Stg',
  SINGLE_COMPRESSOR_TWO_STAGE: '1 Comp, 2 Stg',
  TWO_COMPRESSOR_TWO_STAGE: '2 Comp, 2 Stg',
  VARIABLE_SPEED_COMPRESSOR: 'VS'
}
export const BLOWER_TYPE = { VARIABLE_SPEED: 'VS', NON_VARIABLE_SPEED: 'Non-VS' }
export const REFRIGERANT_TYPE = { r22: 'R-22', r410a: 'R-410A', r454b: 'R-454B' }
export const OUTDOOR_UNIT_TONNAGES = [1.5, 2, 2.5, 3, 3.5, 4, 5]
export const AIRFLOW_INPUT_MODE = {
  constant_cfm: 'Constant Speed',
  0: 'Constant Speed',
  constant_torque: 'Constant Torque',
  1: 'Constant Torque'
}
export const CONTROL_TYPE = { TWO_STAGE_NINETY_PERCENT: '90% 2-Stage', TWO_STAGE_EIGHTY_PERCENT: '80% 2-Stage', MODULATING: 'Modulating' }
export const INDOOR_UNIT_COIL_TONNAGE = [1.5, 2, 2.5, 3, 3.5, 4, 5]
export const GAS_FURNACE_BTUH_PER_STAGE = ['40K', '60K', '80K', '100K', '120K']
export const GAS_FURNACE_EFFICIENCY = ['80%', '90%', 'Condensing']
export const ELECTRIC_HEAT_KW = [4, 5, 8, 10, 15, 20, 25]

export const HEHM_INDOOR_UNIT_TYPE = { Air_Handler: 'airHandler', Furnace: 'furnace' }
export const HEHM_INDOOR_HEAT_TYPE = { None: null, Electric: 'electric', Gas: 'gas', Hydronic: 'hydronic' }
export const HEHM_OUTDOOR_UNIT_TYPE = { Air_Conditioner: 'airConditioner', Heat_Pump: 'heatPump' }
export const HEHM_OUTDOOR_REFRIGERANT_TYPE = { R22: 'R-22', R410A: 'R-410A', R32: 'R-32', R454B: 'R-454B' }
export const HEHM_STAGES = { None: null, 1: 'stage1', 2: 'stage2', 3: 'stage3', Variable_Speed: 'variableSpeed', Modulating: 'modulating' }
